import { ResortsConstants } from './resorts.constants'
import { database } from '../../config/firebase'

const {
    FETCHING_RESORTS,
    FETCHING_RESORTS_SUCCESS,
    FETCHING_RESORTS_FAILURED,
    SETTING_CURRENT_RESORT,
    FETCHING_CITIES,
    FETCHING_CITIES_SUCCESS,
    FETCHING_CITIES_FAILURED,
    FETCHING_ROOMS,
    FETCHING_ROOMS_SUCCESS,
    FETCHING_ROOMS_FAILURED,
    SETTING_CURRENT_PLACE,
    SETTING_CURRENT_ROOM
} = ResortsConstants

// const noname = (locale) => ({
//   type: USER_LOCALE,
//   locale
// });

const fetchResorts = () => {
    return dispatch => {
        dispatch({ type: FETCHING_RESORTS });
        return database.collection('resorts').get()
            .then(resorts => {
                var resortsList = [];
                resorts.docs.map(doc => {
                    resortsList.push(doc.data());
                });
                // console.log('SUCCESS FETCHING RESORTS');
                return dispatch({ type: FETCHING_RESORTS_SUCCESS, resortsList })
            })
            .catch((err) => {
                console.log('FAILED TO FETCH RESORTS');
                console.log(err.code);
                var error = err.code;
                dispatch({ type: FETCHING_RESORTS_FAILURED, error });
                return;
            });
    };

}
const setCurrentResort = (currentResort) => {
    return async (dispatch) => {
        dispatch({ type: SETTING_CURRENT_RESORT, currentResort });
        dispatch({ type: FETCHING_CITIES });
        var currentCities = [];
        await currentResort.cities.forEach(async (element, index) => {
            // console.log(element);
            await database.collection('cities').doc(element).get()
                .then(val => {
                    // console.log(val.data());
                    currentCities.push(val.data());
                    
                })
                .catch(err => {
                    console.log('error fetching cities')
                    var error = err.code;
                    return dispatch({ type: FETCHING_CITIES_FAILURED, error })
                })
        });
        dispatch({ type: FETCHING_ROOMS })
        database.collection('rooms')
            .where("resortId", "==", currentResort.id)
            .get()
            .then(val => {
                var rooms = [];
                val.forEach(function (doc) {
                    // console.log(doc.id, " => ", doc.data());
                    rooms.push(doc.data());
                });
                // console.log('SUCCESS FETCHING ROOMS')
                    dispatch({ type: FETCHING_ROOMS_SUCCESS, rooms });
                    dispatch({ type: FETCHING_CITIES_SUCCESS, currentCities });
                    var place = currentCities[0];
                    dispatch({ type: SETTING_CURRENT_PLACE, place });
             
            })
            .catch(err => {
                console.log(err);
                var error = err.code;
                return dispatch({ type: FETCHING_ROOMS_FAILURED, error })
            })
    };

}

const setCurrentPlace = (place)=>({
    type: SETTING_CURRENT_PLACE,
    place
});

const setCurrentRoom = (currentRoom)=>({
    type: SETTING_CURRENT_ROOM,
    currentRoom
});
// const setCurrentResort = (currentResort) => ({
//     type: SETTING_CURRENT_RESORT,
//     currentResort
// });

export default {
    fetchResorts,
    setCurrentResort,
    setCurrentPlace,
    setCurrentRoom
}